import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all translation files
import commonEN from './locales/en/common.json';
import adminEN from './locales/en/admin.json';
import matchesEN from './locales/en/matches.json';
import authEN from './locales/en/auth.json';

import commonFI from './locales/fi/common.json';
import adminFI from './locales/fi/admin.json';
import matchesFI from './locales/fi/matches.json';
import authFI from './locales/fi/auth.json';

const resources = {
  en: {
    common: commonEN,
    admin: adminEN,
    matches: matchesEN,
    auth: authEN,
  },
  fi: {
    common: commonFI,
    admin: adminFI,
    matches: matchesFI,
    auth: authFI,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    ns: ['common', 'admin', 'matches', 'auth'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['navigator'],
      caches: [],
    },
  });

export default i18n;
export type Resources = typeof resources;
